import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";

/**
 * Api services for places component
 */
export const placesService = {
  addPlace,
  getPlaces,
  updatePlace,
  getPlaceById,
  deletePlace,
};

function getPlaces(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.places + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getPlaceById(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.places + data.id, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function addPlace(payload) {
  // console.log("Payload.........", payload);
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.places, {
      method: "POST",
      headers: {
        Authorization: payload.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function updatePlace(payload) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.places + payload.data.placeUid, {
      method: "PUT",
      headers: {
        Authorization: payload.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}
function deletePlace(payload) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.places + payload.id, {
      method: "DELETE",
      headers: {
        Authorization: payload.token,
        "Content-Type": "application/json",
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
